import Link from 'next/link'
import { Fragment } from 'react'

/**
 * A helper function that wraps URLs in links.
 * @param text text potentially containing URLs
 * @returns a React node with URLs wrapped in anchor tags
 */
export const wrapUrlsInLinks = (text: string): React.ReactNode => {
  // Regular expression to match URLs from https://stackoverflow.com/a/3809435
  const urlRegex =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g

  // Split the text by URLs and keep the URLs in the result array
  const parts = text.split(urlRegex)

  // check if the period is the last character in the text string trimmed
  const lastCharIsPeriod = text.trim().slice(-1) === '.'

  // Map over the parts and wrap URLs with anchor tags
  const wrappedParts = parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // check to see if the URL includes a period at the end of the string
      const lastChar = part.slice(-1)

      if (lastChar === '.' && lastCharIsPeriod) {
        part = part.slice(0, -1)
      }
      return (
        <Fragment key={index}>
          <Link key={index} href={part} target="_blank" rel="noopener noreferrer" className="underline">
            {part}
          </Link>
          {/* Replace the period if it was removed */}
          {lastChar === '.' && lastCharIsPeriod ? '.' : ''}
        </Fragment>
      )
    }
    return part
  })

  // Return the array of React nodes
  return <>{wrappedParts}</>
}
